import videojs from 'video.js';

// Базовый класс способа авторизации
export default class AuthProvider extends videojs.EventTarget {
  constructor(name) {
    super();
    this.name = name;
  }

  /**
   * Функция для загрузки необходимых скриптов и инициализации виджетов
  */
  loadScript() {}

  /**
   * Функция для инициализации процедуры авторизации в сервисе авторизации (соц. сети, email и т.
   * п.)
   */
  authorize() {}
}
